
const constants = {

  // colors for the credit card images
  initialCardColor: 'darkgray',
  dimmedCardColor: 'lightgray',
  selectedCardColor: 'black',

  // used in data masking (for CVV and Credit Card number)
  // if you change this, make sure to change the regex below
  // Unicode U+274A is a large attractive asterisk.
  starChar: '\u274A',
  star4Char: '\u274A'.repeat(4),
  star6Char: '\u274A'.repeat(6),

  // Various Regex expressions used to validate fields on the Normal Donation (and CardScan) pages
  // allows apostrophe and hyphen, but no other non-alpha characters
  nameRegex: /^([A-Za-z' -])+$/,
  cvvRegex: /^[0-9\u274A]{3,4}$/,
  phoneRegex: /^(\+[0-9]{1,3})?[0-9\- )(]{10,18}$/,
  cNumberRegex: /^([AaCc][CcJj]?)?[0-9]{1,15}$/,
  //                 US 5 or 9 digit zip OR  Canada Postal Codes             OR Japanese Postal Codes
  postalCodeRegex: /(^(\d{5}(-?\d{4})?)$)|(^[a-zA-Z]\d[a-zA-Z] \d[a-zA-Z]\d$)|(^\d{3}-\d{4}$)/,
}

export default constants
